import { render, staticRenderFns } from "./file-container.vue?vue&type=template&id=0c58d664&scoped=true&"
import script from "./file-container.vue?vue&type=script&lang=js&"
export * from "./file-container.vue?vue&type=script&lang=js&"
import style0 from "./file-container.vue?vue&type=style&index=0&id=0c58d664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c58d664",
  null
  
)

export default component.exports